import { render, staticRenderFns } from "./ExternalPostTagDetail.vue?vue&type=template&id=36e99e2a"
import script from "./ExternalPostTagDetail.vue?vue&type=script&lang=js"
export * from "./ExternalPostTagDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports